import * as Yup from "yup";
import { validatePhoneWithCountrySelection } from "@kivunova/kivufrontendcommon";

export const buildQuickSupplierSchema = (
  t: (key: string, fallback: string) => string
) =>
  Yup.object({
    name: Yup.string().trim().required(t("name-required", "Name is required")),
    phone: Yup.string()
      .trim()
      .test(
        "phone-validation",
        t("phone-invalid", "Invalid phone number for selected country"),
        function (value) {
          const trimmed = (value ?? "").trim();
          if (!trimmed) return true;
          const { phoneCountryCode } = this.parent;
          return validatePhoneWithCountrySelection(trimmed, phoneCountryCode);
        }
      ),
    phoneCountryCode: Yup.string().when("phone", {
      is: (phone: string) => Boolean(phone && String(phone).trim()),
      then: (schema) =>
        schema.required(t("country-code-required", "Country code is required")),
      otherwise: (schema) => schema.optional()
    }),
    email: Yup.string()
      .trim()
      .test(
        "email-format",
        t("email-invalid", "Invalid email format"),
        (value) => {
          if (!value || !String(value).trim()) return true;
          return Yup.string().email().isValidSync(value);
        }
      )
      .test(
        "phone-or-email",
        t(
          "phone-or-email-required",
          "Provide a phone number or an email address"
        ),
        function (value) {
          const email = (value ?? "").trim();
          const phone = (this.parent.phone ?? "").trim();
          return Boolean(phone || email);
        }
      )
      .optional()
  });

export type QuickSupplierFormValues = {
  name: string;
  phone?: string;
  phoneCountryCode?: string;
  email?: string;
};
